module.exports = __webpack_public_path__ + "img/小房书bg@2x.93f12416.png";